// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"85373df9","350":"8077b09d","453":"46aa77db"}[chunkId] + ".chunk.js";
};